import {
  Search as SearchIcon,
  BarChart2 as BarChart2Icon,
  Database as DatabaseIcon,
  User as UserIcon,
  PenTool as PenToolIcon,
} from 'react-feather'

import agents from './agents'

const tools = {
  names: {
    search_platform_docs_tool: 'Documentação da plataforma',
    search_lgpd_law_tool: 'Lei Geral de Proteção de Dados',
    search_security_info_tool: 'Segurança da Informação',
    statistics_consent_forms: 'Consentimentos',
    statistics_data_processes: 'Processos',
    statistics_privacy_policies: 'Documentos',
    create_privacy_policy: 'Criação de Documento',
    update_privacy_policy_content: 'Atualização de Documento',
    list_privacy_policies: 'Documentos',
    show_privacy_policy_content: 'Documentos',
    list_data_processes: 'Processos',
    show_data_process: 'Processo',
    convert_markdown_to_html: 'Conversão de Conteúdo',
    statistics_question_controls: 'Medidas de segurança',
    statistics_questionnaires: 'Questionários',
    statistics_suppliers: 'Gestão de Terceiros',
    get_current_company_context: 'Empresa',
    get_current_dpo_context: 'Encarregado (DPO)',
    get_current_user_context: 'Usuário',
    transfer_to_agent: 'Agente Especializado',
    list_document_templates: 'Documentos Modelos',
    show_document_template: 'Documento Modelo',
    generate_document_template: 'Geração de Documento',
    list_governance_knowledge_bases: 'Base de Conhecimento',
    show_governance_activity: 'Controle de Governança',
    show_governance_question_template: 'Questão de Governança',
    list_governance_template_documents: 'Documentos de Referência',
    get_governance_template_document_content: 'Documento de Referência',
    list_governance_evidences: 'Evidências do Controle',
    read_governance_evidence: 'Evidência do Controle',
    read_governance_template_document: 'Documento de Referência',
    read_governance_document: 'Documento da Plataforma',
    show_governance_activity_evidence: 'Evidência do Controle',
    link_privacy_policies_to_governance_activity_evidence:
      'Evidência do Controle',
    ...agents.names,
  },
  categories: {
    search_platform_docs_tool: 'knowledge_search',
    search_lgpd_law_tool: 'knowledge_search',
    search_security_info_tool: 'knowledge_search',
    statistics_consent_forms: 'platform_stats',
    statistics_data_processes: 'platform_stats',
    statistics_privacy_policies: 'platform_stats',
    create_privacy_policy: 'platform_action',
    update_privacy_policy_content: 'platform_action',
    convert_markdown_to_html: 'platform_action',
    list_privacy_policies: 'platform_data',
    show_privacy_policy_content: 'platform_data',
    list_data_processes: 'platform_data',
    show_data_process: 'platform_data',
    statistics_question_controls: 'platform_stats',
    statistics_questionnaires: 'platform_stats',
    statistics_suppliers: 'platform_stats',
    get_current_company_context: 'platform_context',
    get_current_dpo_context: 'platform_context',
    get_current_user_context: 'platform_context',
    transfer_to_agent: 'agent_transfer',
    list_document_templates: 'platform_data',
    show_document_template: 'platform_data',
    generate_document_template: 'platform_action',
    list_governance_knowledge_bases: 'knowledge_search',
    show_governance_activity: 'platform_data',
    show_governance_question_template: 'platform_data',
    list_governance_template_documents: 'platform_data',
    get_governance_template_document_content: 'platform_action',
    list_governance_evidences: 'platform_data',
    read_governance_evidence: 'platform_data',
    read_governance_template_document: 'platform_data',
    read_governance_document: 'platform_data',
    show_governance_activity_evidence: 'platform_data',
    link_privacy_policies_to_governance_activity_evidence: 'platform_action',
    [agents.DOCUMENT_AGENT]: 'agent_transfer',
    [agents.POP_AGENT]: 'agent_transfer',
    [agents.POP_DRAFT_AGENT]: 'agent_transfer',
    [agents.POP_REVIEW_AGENT]: 'agent_transfer',
    [agents.WORKFLOW_AGENT]: 'agent_transfer',
    [agents.WORKFLOW_PROCESS_READER_AGENT]: 'agent_transfer',
    [agents.DOCUMENT_CREATION_AGENT]: 'agent_transfer',
    [agents.DOCUMENT_UPDATE_AGENT]: 'agent_transfer',
    [agents.POP_DOCUMENT_CREATION_AGENT]: 'agent_transfer',
    [agents.GOVERNANCE_PROJECT_COPILOT_AGENT]: 'agent_transfer',
  },
  categoryLabels: {
    knowledge_search: {
      calling: 'Buscando informações sobre',
      done: 'Analisando informações sobre',
    },
    platform_stats: {
      calling: 'Buscando estatísticas de',
      done: 'Analisando estatísticas de',
    },
    platform_data: {
      calling: 'Buscando dados sobre',
      done: 'Analisando dados sobre',
    },
    platform_action: {
      calling: 'Executando',
      done: 'Concluído',
    },
    platform_context: {
      calling: 'Carregando contexto de',
      done: 'Contexto carregado',
    },
    agent_transfer: {
      calling: 'Acionando',
      done: 'Integrando resultado do',
    },
  },
  categoryIcons: {
    knowledge_search: SearchIcon,
    platform_stats: BarChart2Icon,
    platform_data: DatabaseIcon,
    platform_action: PenToolIcon,
    platform_context: UserIcon,
    agent_transfer: null,
  },
}

export default tools
